import React, {Component} from 'react';
import {Collapse, Icon} from 'antd';
import * as moment from 'moment';

const {Panel} = Collapse;

export default class Cabinet extends Component {
    render() {
        const {fileList, onClick, onDelete} = this.props;
        const categorized = {};
        fileList.forEach(file => {
            if (file.status === 'uploading') {
                return;
            }

            if (!categorized[file.docType]) {
                categorized[file.docType] = []
            }
            categorized[file.docType].push(file);
        });
        const getColor = (expiry) => {
            let color = '#52c41a';
            if (!expiry) return color;

            const diff = moment(expiry.date, 'YYYY-MM-DD').diff(moment(), 'days');
            if (diff < 0) {
                color = '#f5222d';
            } else if (diff < 60) {
                color = '#faad14'
            }
            return color;
        };

        const onRemove = file => e => {
            e.preventDefault();
            e.stopPropagation();

            return onDelete(file);
        };

        return (
            <Collapse bordered={false} accordion>
                {Object.keys(categorized).map((type, i) => {
                    const files = categorized[type];
                    return (
                        <Panel header={<span style={{color: getColor(files[0].expiry)}}>{type}</span>} key={i}>
                            {files.map((file, i) => {
                                return (
                                    <div className="ant-upload-list-item" key={i}>
                                        <div className="ant-upload-list-item-info" style={{position: 'relative'}}>
                                            <Icon type="paper-clip"/>
                                            <a href={file.url} className="ant-upload-list-item-name" onClick={onClick(file)} style={file.linkProps.style}>{file.name}</a>
                                        </div>
                                        <Icon type="cross" onClick={onRemove(file)}/>
                                    </div>
                                );
                            })}
                        </Panel>
                    )
                })}
            </Collapse>
        )
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/property/FileCabinet.js